export function evaluateEnvFlag (flag) {
  try {
    flag = flag.toLowerCase()
    return (flag === 'true')
  } catch (error) {
    return false
  }
}
